import { SaveSettingsFn } from "../../../../rest/settings";
import { SettingsStore } from "../SettingsStore";
import { FlagActions } from "../../../flux/Flag/FlagActions";
import { ErrorActions } from "../../../flux/Error/ErrorActions";
import { QuantityUnitSetting } from "../../../../models/Settings";
import { stringToInt } from "../../../../converters/converters";
import { Polyglot } from "../../../../polyglot";
import { LanguagePack } from "../../../../../translations";
import { appNavigator } from "../../../routes";
import { Command } from "../../../../Command";

// Settings UI component exec SaveSettingsCommand on Save click
export class SaveSettingsCommand implements Command
{
    private readonly flagActions = new FlagActions();
    private readonly errorActions = new ErrorActions();
    
    constructor(
        private polyglot: Polyglot,
        private languages: Map<string, LanguagePack>,
        private rerender: () => void,
        private saveSettings: SaveSettingsFn, private getCurrentDivisionId: () => number, private settingsStore: SettingsStore, private inProgressDispatchToken: string, private errorDispatchToken: string)
    {
    }
    
    execute = () => {
        const state = this.settingsStore.getState();
        const { passwordFlag, password, passwordConfirmation, selectedLanguage, quantitySettings } = state;

        const setError = (msg: string) => this.errorActions.setError(new Error(msg), this.errorDispatchToken);
        if(passwordFlag) {
            if(password !== passwordConfirmation) {
                setError(this.polyglot.t('settings.validation_err.password_mismatch'));
                return;                
            }
            if(password === null || password === '') {
                setError(this.polyglot.t('settings.validation_err.password_not_set'));
                return;
            }
        }

        const prefUnits = getPreferredUnits(quantitySettings);
        this.flagActions.set(this.inProgressDispatchToken);
        this.saveSettings({
                DivisionId: this.getCurrentDivisionId(),
                PreferredUnits: prefUnits,
                EmailAddresses: this.settingsStore.getState().emails,
                Locale: selectedLanguage.code,
                NewPassword: passwordFlag ? password : null,
                DontAlertLeavingRed : this.settingsStore.getState().dontAlertLeavingRedZone,
                DontAlertEnteringYellow : this.settingsStore.getState().dontAlertEnteringYellowZone,
                DontAlertLeavingYellow : this.settingsStore.getState().dontAlertLeavingYellowZone
            })
            .then(() => {
                this.polyglot.locale(selectedLanguage.code);
                this.polyglot.replace(this.languages.get(selectedLanguage.code));
                appNavigator.closeSettings();
                this.rerender();
            })
            .catch(err => this.errorActions.setError(err, this.errorDispatchToken))
            .then(() => this.flagActions.reset(this.inProgressDispatchToken)); // finaly
    }
}

const getPreferredUnits = (settings: {[key: number]: number}): QuantityUnitSetting[] => {
    return Object.keys(settings).map(k => ({
        QuantityId: stringToInt(k),
        UnitId: settings[k]
    }));
}


// WEBPACK FOOTER //
// ./src/app/components/Settings/commands/SaveSettingsCommand.ts